/**
 * StockCountersProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import StockCountersContext from './stock-counters-context'
import { fetchStockCounters } from './stock-counters-api'

export default function StockCountersProvider({ children }) {
  const state = {
    fetchStockCounters
  }
  return (
    <StockCountersContext.Provider value={state}>
      {children}
    </StockCountersContext.Provider>
  )
}
